import React, { useState, useEffect } from "react";
import { useIntl } from 'react-intl'
import Filter from "./filter";
import FilterIcon from "../icons/filterIcon";

export const Header = ({field, rows, filter, dragging, onFilter}) => {
    
    const [anchorEl, setAnchorEl] = useState(null);
    const intl = useIntl();

    useEffect(() => {
        if (dragging) {
            setAnchorEl(null);
        }
    }, [dragging])
    
    const openFilter = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    
    const closeFilter = () => {
        setAnchorEl(null);
    };

    const handleFilter = (filter) => {
        setAnchorEl(null);
        onFilter(filter)
    }

    const open = Boolean(anchorEl);

    const isFiltered = field && filter && filter.selectedItems.length && field.field === filter.field.field;

    return (
        <div>
            <div
                className="task-header-title"
                role="columnheader"
                onClick={(e) => field.filtering && openFilter(e)}
            >
                <span className={open || isFiltered ? " selected" : ""}>
                    {field.label ? intl.formatMessage(field.label) : ''}
                    {field.filtering && <span className="filter-icon">
                        <FilterIcon />
                    </span>}
                </span>
            </div>
            {open && (
                <Filter
                    field={field}
                    filter={filter}
                    rows={rows}
                    clickFnApply={handleFilter}
                    clickFnClose={closeFilter}
                    anchor={anchorEl}
                />
            )}
        </div>

    )
}